import { render, staticRenderFns } from "./PublicTopBar.vue?vue&type=template&id=4b8e0a9d&scoped=true"
import script from "./PublicTopBar.vue?vue&type=script&lang=js"
export * from "./PublicTopBar.vue?vue&type=script&lang=js"
import style0 from "./PublicTopBar.vue?vue&type=style&index=0&id=4b8e0a9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8e0a9d",
  null
  
)

export default component.exports